module.exports = __webpack_public_path__ + "cr.6991f72da2f9a055dbc5.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/cr.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/cr.svg
// module chunks = styles